// You can write more code here

/* START OF COMPILED CODE */

import Obstacle from './Obstacle';
/* START-USER-IMPORTS */
import { BodyTypes } from '../../LevelManager';
import { ObstacleEffectController } from '../../ObstacleEffectController';
import { SplatEffectsLayer } from '../../../SplatEffectsLayer';

/* END-USER-IMPORTS */

export default class ObstacleIcePatch extends Obstacle {
  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 138.5, y ?? 40, texture || 'game', frame ?? 'obstacle-ice-patch.png');

    // this (prefab fields)
    this.slowStrength = 0.5;
    this.hitEffect = 'slide';

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  public init() {
    (this.body as MatterJS.BodyType).label = BodyTypes.Obstacle;

    super.init();
  }

  public onHit(wasPlayer: boolean, isSingleUse: boolean, hitPointX: number, delay: number) {
    // this.alpha = 0;
    // this.hasBeenHit = true;

    this.scene.events.emit(ObstacleEffectController.events.ShowEffect, this, this.x, this.y);

    if (wasPlayer) {
      this.scene.events.emit(SplatEffectsLayer.events.SplatIce, hitPointX - this.scene.cameras.main.scrollX, this.y - this.scene.cameras.main.scrollY, 5);
    }

    super.onHit(wasPlayer, false, hitPointX, 500);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
